import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import images from "../../images";
import { useGetUnreadInboxCountQuery } from "../../services/apiSlice";

const Footer = ({ backgroundClass = "bg-[#ECEEFF]" }) => {
  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");
  const refreshToken =
    localStorage.getItem("refreshToken") ||
    sessionStorage.getItem("refreshToken");
  const isAuthenticated = accessToken || refreshToken;

  const location = useLocation();
  const { data: unreadData } = useGetUnreadInboxCountQuery(undefined, {
    skip: !isAuthenticated,
  });
  const unreadCount = unreadData?.total || 0;

  const navItems = [
    {
      to: "/",
      label: "Home",
      icon: images.HomeSprint5,
      activeIcon: images.HomeActiveSprint5,
    },
    {
      to: "/favorites",
      label: "Favorites",
      icon: images.favouritesSprint5,
      activeIcon: images.favouritesActiveSprint5,
    },
    {
      to: "/quests",
      label: "Quests",
      icon: images.RallyStickers,
      activeIcon: images.RallyStickerActive,
    },
    {
      to: "/profile/inbox",
      label: "Inbox",
      icon: images.Inbox,
      activeIcon: images.InboxActive,
    },
    {
      to: "/profile",
      label: "Profile",
      icon: images.profileSprint5,
      activeIcon: images.ProfileActive,
    },
  ];

  return (
    <nav
      className={`w-full max-w-[428px] flex items-center justify-between
       px-[36px] py-[24px]
       ${backgroundClass}
       shadow-[0_0_15px_0_rgba(0,0,0,0.10)]`}
    >
      {navItems.map((item) => {
        const isActive = location.pathname === item.to;

        if (item.label === "Quests") {
          return (
            <NavLink
              key={item.label}
              to={item.to}
              className="flex flex-col items-center relative"
              title={item.label}
            >
              <img
                src={isActive ? item.activeIcon : item.icon}
                alt={item.label}
                className="w-7 h-7"
              />
            </NavLink>
          );
        } else if (item.label === "Inbox") {
          return (
            <NavLink
              key={item.label}
              to={item.to}
              className="flex flex-col items-center relative"
              title={item.label}
            >
              <div className="relative">
                {" "}
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={item.label}
                  className="w-9 h-9"
                />
                {unreadCount > 0 && (
                  <div
                    className="absolute flex flex-col justify-center items-center
                               bg-[#EF4056] text-[#ECEEFF] font-bold text-[9px] font-['Figtree']
                               rounded-full border-[1.5px] border-[#ECEEFF]"
                    style={{
                      width: "16px",
                      height: "16px",
                      top: "0px",
                      right: "-3px",
                      zIndex: 10,
                    }}
                  >
                    {unreadCount > 99 ? "99+" : unreadCount}
                  </div>
                )}
              </div>
            </NavLink>
          );
        }
        return (
          <NavLink
            key={item.label}
            to={item.to}
            className="flex flex-col items-center"
            title={item.label}
          >
            <img
              src={isActive ? item.activeIcon : item.icon}
              alt={item.label}
              className="w-9 h-9"
            />
          </NavLink>
        );
      })}
    </nav>
  );
};

export default Footer;
